export function formatNumber(data: number): string {
  const power: number = Math.log10(data);
  let unit: string = '';
  let result: number = data;
  if (power >= 6) {
    unit = 'M';
    result = parseFloat((data / (10 ** 6)).toFixed(2));
  }
  return `${result.toLocaleString()}${unit}`;
}